// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"2440":"datadogProfiler","3581":"datadogRecorder"}[chunkId] + "." + {"2440":"a74d06bcccdb1e7a","3581":"36b85c73dd1eee51"}[chunkId] + ".js";
};